import Blockquote from '@tiptap/extension-blockquote';

const isFilingSourceQuote = (value: unknown) =>
    typeof value === 'string' && value.split(/\s+/).includes('filing-source-quote');

export const FilingAwareBlockquote = Blockquote.extend({
    addAttributes() {
        return {
            class: {
                default: null,
                parseHTML: (element) => element.getAttribute('class'),
                renderHTML: (attributes) => (attributes.class ? { class: attributes.class } : {}),
            },
            contenteditable: {
                default: null,
                parseHTML: (element) => (element.classList.contains('filing-source-quote') ? 'false' : null),
                renderHTML: (attributes) =>
                    isFilingSourceQuote(attributes.class) ? { contenteditable: 'false' } : {},
            },
        };
    },
});
